export default{
  NAV_COLLAPSE(state,value){
    state.navcollapse= value
  },
  RESOURCE_LIST(state,arr){
    state.resourcelist= arr
  },
  SALES_RESOURCE_LIST(state,arr){
    state.salesresourcelist = arr;
  },
  SELECT_LIST(state,arr){
    state.selectlist= arr
  },
  LANGUAGE_TYPE(state,str){
    state.languagetype= str
  },
  LOGIN_TYPE(state,str){
    state.logintype= str
  },
  CONTROL(state,obj){
    state.control= obj
  },
  CONTROL_ROUTER(state,obj){
    state.controlrouter= obj
  },
  // reserve
  SALE_ADVICE_DATA(state,data){
    state.saleAdviceData = data
  },
  SALE_ADVICE_DATA_Att(state,data){
    state.saleAdviceDataAtt = data
  },
  // 判断按钮
  BTN_STATUS(state,obj){
    state.btnStatus = obj
  },
  NAV_PATH_LIST_ADD(state,obj){
    // if ( state.navPathList.length>0) {
    //   for(var i=0;i<state.navPathList.length;i++){
    //     if(state.navPathList[i].name==obj.name){
    //       state.navPathList.remove(state.navPathList[i])
    //       // return
    //     }else{
    //       state.navPathList.push(obj);
    //       // return
    //     }
    //   }
    // }else{
    //   state.navPathList.push(obj);
    // }
    state.navPathList.push(obj);
  },
  NAV_PATH_LIST_REMOVE(state,num){
    if(state.navPathList){
      state.navPathList = state.navPathList.slice(0, num-1);
    }
  },
  // 没有用到
  NAV_PATH_LIST_Change(state,obj){
    state.navPathList = [...obj];
  },
  WAITING_TOTAL(state,total){ //等待审批数量,小红点
    state.waitingTotal = total
  },
  CHANNEL_WAITING_TOTAL(state,total){ //等待审批数量,小红点(渠道)
    state.channelWaitingTotal = total
  },

  SET_SHOW_LOADING(state,obr){
    state.show_loading = obr
  },
  ALLPROJECT_TAB(state,obr){
    state.allprojecttab = obr
  },
  REA_TAB(state,obr){
    state.reatab = obr
  },
  DOMAIN_TAB(state,obr){
    state.domaintab = obr
  },
  APPROVAL_TAB(state,obr){
    state.approvaltab = obr
  },
  SHARED_LISTING_TAB(state,obr){
    state.sharedlistingtab = obr
  },
  LISTING_APPROVAL_TAB(state,obr){
    state.listingapprovaltab = obr
  },
  AGENTBOX_TAB(state,obr){
    state.agentboxtab = obr
  },
  CAMPAIGN_HOST_TAB(state,obr){
    state.campaignHostTab = obr
  },
  MARKETPLACE_TAB(state,obr){
    state.marketplacetab = obr
  },
  MARKETPLACE_SUBTAB(state,obr){
    state.marketplacesubtab = obr
  },
  MENU_ACTIVE(state,val){
    state.menuactive = val
  },
  INTERNAL_PENDING_COUNT(state,obr){ 
    state.internalpendingcount = obr
  },
  MARKETPLACE_PENDING_COUNT(state,obr){
    state.marketplacependingcount = obr
  },
  CONTACT_BULK_UNLOCK(state){
    state.contactBulkUnlock = new Date().getTime();
  },
  DEPARTMENT_TAB(state,obr){
    state.departmenttab = obr
  },
  saveProjectType(state, value){
    state.projectType = value;
  },
  saveMenuNav(state, obj){
    state.menunav = obj;
  },
  CAMPAIGN_DATA(state,obj){
    state.campaignData = obj;
  },
  SINGLE_LIST_DATA(state,obj){
    state.singleListData = obj;
  },
  SHARED_LIST_DATA(state,obj){
    state.sharedListData = obj;
  },
  LOGO_IMAGE_DARK(state, str){
    state.logoimagedark = str;
  },
  SESSION_EXPIRED(state, str){
    state.sessionExpired = str;
  },
  TOKEN(state, str){
    state.token = str;
  },
  EDITION(state, str){
    state.edition = str;
  },
  COMMISSION_MODULE_ENABLED(state, val){
    state.commissionModuleEnabled = val;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js